export const LIST_LOG = 'LIST_LOG';
export const LIST_LOG_SUCCESS = 'LIST_LOG_SUCCESS';
export const LIST_LOG_ERROR = 'LIST_LOG_ERROR';